/* eslint-disable @typescript-eslint/no-explicit-any */ import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { getSettingEnableCartCheckoutThrottle } from "@faire/retailer-visitor-shared/settings/getSettingEnableCartCheckoutThrottle";
import { throttleIfPossible } from "@faire/web--source/common/globals/throttleIfPossible";
var THROTTLE_TIME = 250;
// This is a patch to reduce multiple api calls made at very short span of time
// (could a mouse issue, keyboard issue, not necessarily bad user behavior)
// we should have a more robust solution (but more expensive in terms of time development)
// but to give us some room to brief we are using a FE throttle
// This is the proper way to specify any function
export var commonThrottle = function(func) {
    var throttled = throttleIfPossible(func, THROTTLE_TIME);
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (getSettingEnableCartCheckoutThrottle()) {
            return throttled.apply(void 0, _to_consumable_array(args));
        } else {
            return func.apply(void 0, _to_consumable_array(args));
        }
    };
};
